import React from 'react';
import { bool, func } from 'prop-types';
import cn from 'classnames';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { useChooseVariationContext } from '../../Context';
import { VARIATION_TYPE } from '../../ChooseVariation/constants';
import classes from './index.module.scss';

const MobileNavigation = ({ isDisabled, isLoading, onPurchase }) => {
    const { selectedVariation, hasFreeVariations } = useChooseVariationContext();
    const buyLabel = 'buy_logo_mobile';

    return (
        <>
            {selectedVariation.type !== VARIATION_TYPE.ORDERED && (
                <div className={classes.buttonWrapper}>
                    <Button
                        className={cn(classes.button, classes.roundButton)}
                        color={Button.COLORS.BLUE}
                        disabled={isDisabled || isLoading}
                        loading={isLoading}
                        onClick={onPurchase}
                    >
                        <I18n
                            k={`logo_maker_perseus.choose_variation.navigation.${
                                hasFreeVariations ? 'download' : buyLabel
                            }`}
                        />
                    </Button>
                </div>
            )}
        </>
    );
};

MobileNavigation.propTypes = {
    isDisabled: bool,
    isLoading: bool,
    onPurchase: func,
};

export default MobileNavigation;
